
/**
 * 由 utils/pickupConfirm.openPickupConfirm(vm, order, onConfirmed) 用 Quasar Dialog 插件打开；
 * props 由 Dialog.create 透传。成功后 $emit('ok') 关窗并回调调用方刷新，失败保留弹窗。
 *
 * Quasar v1 自定义弹窗契约（Dialog.create({ component })，见 quasar/src/utils/private/global-dialog.js）：
 * 插件把本组件当作 `<QGlobalDialog>` 的子节点渲染，并在其 mounted 里调 `this.$refs.dialog.show()`，
 * 且只监听本组件的 `ok` / `hide` 两个事件（emit ok 触发回调；emit hide 销毁实例并触发取消回调）。
 * 因此本组件必须：根节点是 q-dialog、自己暴露 show()/hide() 两个方法、把 q-dialog 的 @hide 转发成 $emit('hide')。
 * 少任何一样 → 无遮罩层（页面里 .q-dialog 为 0）且控制台报 show is not a function。
 */
export default {
  name: 'PickupConfirmDialog',
  props: {
    // 履约订单 id（确认接口按 fo id 解析，与订单卡/详情同一 id）
    orderId: { type: String, default: '' },
    // 该订单当前自提码（字符串原样；历史长码也能显示）
    pickupCode: { type: String, default: '' },
    // 点遮罩不关窗（店员正在核对码，误触不该丢上下文）；由 Dialog.create 传入
    persistent: { type: Boolean, default: true }
  },
  data () {
    return { loading: false, error: '' }
  },
  methods: {
    // ↓↓ Quasar 自定义弹窗三件套：插件只认这三个入口
    show () { this.$refs.dlg.show() },
    hide () { this.$refs.dlg.hide() },
    onDialogHide () { this.$emit('hide') },
    onCancel () {
      if (this.loading) return
      this.hide()
    },
    async submit () {
      if (this.loading) return // 重复点击保护（按钮 disabled 之外再兜一层）
      this.loading = true
      this.error = ''
      try {
        // 码随请求回传：后端 fail-closed（库存量码时必填且相等，见 admin-mobile.js confirm-pickup），
        // 这里回传的正是弹窗展示给店员核对过的那个码，人工核对 + 服务端校验两道都在。
        const res = await this.axios.post(`/admin-mobile/orders/${this.orderId}/confirm-pickup`, { pickup_code: this.pickupCode || '' })
        const body = res && res.data
        if (!body || body.code !== 200) {
          // 业务失败（未验货/已完成/码不符…）：留在弹窗内显示原因，不关窗
          this.error = (body && body.message) || '操作失败，请重试'
          return
        }
        if (this.$toast) this.$toast.success('已确认自提，订单完成')
        // 先 ok（插件据此判定"正常完成"，不跑取消回调）再关窗（触发 hide → 插件销毁实例）
        this.$emit('ok', body)
        this.hide()
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message) || '操作失败，请检查网络后重试'
        this.error = msg
      } finally {
        this.loading = false
      }
    }
  }
}
